import React from 'react';
import About from './About';
import Banner from './Banner';
import ContactMe from './ContactMe';
import Footer from './Footer';
import Navbar from './Navbar';
import Projects from './Projects';
import Worksummary from './Worksummary';
const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <About></About>
            <Projects></Projects>
            <ContactMe></ContactMe>
            <Footer></Footer>
        </div>
    );
};

export default Home;